const THEME_STORAGE_KEY = 'ktc_theme_mode';
const THEME_EVENT = 'ktc-theme-mode-change';

const sanitizeMode = (value) => (String(value || '').toLowerCase() === 'light' ? 'light' : 'dark');

export const getPreferredThemeMode = () => {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return sanitizeMode(stored);
  } catch {
    return 'dark';
  }
};

export const setPreferredThemeMode = (mode) => {
  const next = sanitizeMode(mode);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, next);
  } catch {
    // ignore storage errors
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: { mode: next } }));
  }
  return next;
};

export const onThemeModeChange = (callback) => {
  if (typeof window === 'undefined') return () => {};

  const onCustom = (event) => {
    const mode = sanitizeMode(event?.detail?.mode);
    callback(mode);
  };
  const onStorage = (event) => {
    if (event.key !== THEME_STORAGE_KEY) return;
    callback(sanitizeMode(event.newValue));
  };

  window.addEventListener(THEME_EVENT, onCustom);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(THEME_EVENT, onCustom);
    window.removeEventListener('storage', onStorage);
  };
};

export const toggleThemeMode = () => {
  const current = getPreferredThemeMode();
  return setPreferredThemeMode(current === 'light' ? 'dark' : 'light');
};

